export const sumBy = <T,>(items: T[], by: (i: T) => number) => items.map(by).reduce((p, c) => p + c, 0)
